var path = 'templates/post-single.html';
var html = "<md-content flex=60 class=\"connect md-padding\" style=height:100%> <md-card class=post ng-init=\"user = users.get(post.uid)\" style=display:block ng-include=\"'templates/partial/post.html'\"> </md-card> </md-content> <md-content flex=40 class=md-padding ng-include=\"'templates/partial/user_status.html'\"> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/post-single.html
// module id = 53
// module chunks = 0